import * as React from 'react'
import * as R from 'ramda'
import classNames from 'classnames'

import { services } from './Navbar'
import { Container } from './Container'

interface Service {
  linkTitle: string
  link: string
  groupName?: string
}

const servicesArray = Object.values(services)
const brakeRepairServices: Service[] = []
const generalMaintenanceServices: Service[] = []
const otherServices: Service[] = []
servicesArray.forEach((service) => {
  if (service.groupName === 'Brake Services') {
    brakeRepairServices.push(service)
  } else if (service.groupName === 'General Maintenance' || service.groupName === 'Lights') {
    generalMaintenanceServices.push(service)
  } else {
    otherServices.push(service)
  }
})
const otherServicesGroups = Object.entries(R.groupBy((service) => service.groupName, otherServices))

type Props = {
  cityName?: string
  className?: string
}

export const ServicesSection: React.FC<Props> = ({ cityName, className }) => {
  return (
    <section className={classNames('pt-0 pb-0', className)}>
      <Container className="text-center">
        <h2>{cityName ? `${cityName} ` : ''}BRAKE REPAIR SERVICES</h2>
        <p className="description mb-4 pb-0">
          We offer Top Notch Brake Repair Services, choose one that you want to be delivered right on your door steps.
        </p>

        <ul className="list-none m-0 p-0 flex flex-wrap">
          {brakeRepairServices.map((service) => (
            <li key={service.link} className="w-full ml-0 mb-2 sm:w-1/2">
              <a href={service.link}>{service.linkTitle}</a>
            </li>
          ))}
        </ul>

        <h2 className="mt-8">{cityName ? `${cityName} ` : ''}GENERAL MAINTENANCE</h2>
        <p className="description mb-4 pb-0">
          Nubrakes: Your Trusted Brake Specialists, Committed to Comprehensive Auto Care Solutions for Unmatched
          Performance and Customer Satisfaction.
        </p>

        <ul className="list-none m-0 p-0 flex flex-wrap ">
          {generalMaintenanceServices.map((service) => (
            <li key={service.link} className="w-full ml-0 mb-2 sm:w-1/2">
              <a href={service.link} className="text-lg">
                {service.linkTitle}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex flex-wrap justify-center mt-4">
          {otherServicesGroups.map(([groupName, groupServices]) => {
            return (
              <div key={groupName} className="w-full sm:w-1/2 p-2">
                <h2>{groupName}</h2>
                <ul className="list-none m-0 p-0">
                  {groupServices.map((service) => {
                    return (
                      <li className="mb-4" key={service.link}>
                        <a href={service.link}>{service.linkTitle}</a>
                      </li>
                    )
                  })}
                </ul>
              </div>
            )
          })}
        </div>
      </Container>
    </section>
  )
}
